import http from '@http';
import apis from './api';

const axios = http();

export default class SystemService {
    static sendPhoneCode(params) {
        return axios.post(apis.phoneCode, params);
    }

    static getLotteryCount(params) {
        return axios.post(apis.getLotteryCount, params);
    }

    static lottery(params) {
        return axios.post(apis.lottery, params);
    }

    static getchance(params) {
        return axios.post(apis.getchance, params);
    }

    static lotteryResult(params) {
        return axios.post(apis.lotteryResult, params);
    }
}
